module.exports = __webpack_public_path__ + "img/CDO.619c5c62.jpg";